import { expVal } from '@confluence/feature-experiments';
import { useIsNewUser } from '@confluence/targeting/entry-points/useIsNewUser.ts';

const FIRST_TWO_WEEKS_THRESHOLD = 14;

export const useCfind5291TemplateTouchpoint = () => {
	const { isNewUser, loading: isNewUserLoading } = useIsNewUser({
		activeDaysThreshold: FIRST_TWO_WEEKS_THRESHOLD,
	});

	// If still loading, don't enable yet
	if (isNewUserLoading) {
		return { isEnabled: false, loading: true };
	}

	// Exclude users not within their first 2 weeks after being onboarded
	if (!isNewUser) {
		return { isEnabled: false, loading: false };
	}

	return {
		isEnabled: expVal('cfind-5291-template-touchpoint', 'isEnabled', false),
		loading: false,
	};
};
